import PropertyCommand from '@/components/common/propertyPopoverOverlay/PropertyCommand.tsx'
import { PopoverOverlayT } from '@/components/common/propertyPopoverOverlay/PopoverOverlay.tsx'
import { useHandleProperties } from '@/components/common/propertyPopoverOverlay/useHandleProperties.tsx'
import Property from '@/components/common/propertyPopoverOverlay/Property.tsx'
import SelectFallback from '@/components/common/propertyPopoverOverlay/overlay/SelectFallback.tsx'
import { useTranslation } from 'react-i18next'
import PropertyGoBackNew from '../PropertyGoBackNew'
import { useEffect } from 'react'

type PropsT = PopoverOverlayT & {
  searchLabel?: string
  handleClose: () => void
  open: boolean
}

export default function OverlaySelectOpened({
  properties,
  searchLabel,
  handleClose,
  showSearch,
  open,
  selectAll,
  ...props
}: PropsT) {
  const {
    setCurrentProperties,
    currentProperties,
    handleGoBack,
    propertiesFlat,
    selectedNestedProperties,
    handleSelectParent,
    handleValueChange,
    pureProps,
  } = useHandleProperties(
    properties,
    props.onSelectParent,
    open,
    selectAll,
    props.showAllSearchResults,
    props.debug,
  )
  const { t } = useTranslation()

  useEffect(() => {
    if (open && selectedNestedProperties.length === 0) {
      // prevent resetting when selecting nested property
      setCurrentProperties(properties)
    }
  }, [open, properties, setCurrentProperties, selectedNestedProperties.length])

  if (pureProps.length === 0) {
    return (
      <SelectFallback
        fallbackMessage={props.fallbackMessage ?? t(`common.noDataFound`)}
        onClick={handleClose}
      />
    )
  }

  return (
    <PropertyCommand
      propertiesFlat={propertiesFlat}
      setCurrentProperties={setCurrentProperties}
      showSearch={showSearch}
      searchLabel={searchLabel}
      inputClassName={` text-xs `}
      handleValueChange={handleValueChange}
      handleSearch={props.handleSearch}
      showAllSearchResults={props.showAllSearchResults}
      className={`pt-2`}
      initialProperties={properties}
      selectedNestedProperties={selectedNestedProperties}
      selectedParent={props.selectedParent}
    >
      {currentProperties.map((property, index) => {
        return (
          <Property
            key={`${property.id || property.value}_${index}`}
            setCurrentProperties={setCurrentProperties}
            property={property}
            handleOpenChange={handleClose}
            parent={`overlay`}
            handleSelectParent={handleSelectParent}
            {...props}
          />
        )
      })}
      {selectedNestedProperties.length > 0 && (
        <PropertyGoBackNew handleGoBack={handleGoBack} parent={`popover`} />
      )}
    </PropertyCommand>
  )
}
